import * as React from 'react';

import ConsumerEnrollButtonNotConfigurable from 'bundles/unified-description-page-common/components/enroll/consumer/ConsumerEnrollButtonNotConfigurable';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import { getFormattedCourseDataFromConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/utils/getFormattedCourseDataFromConsumerProductPageFieldsFragment';

const ConsumerCourseEnrollButtonNotConfigurable = ({
  pageData,
  size,
  onlyShowButton,
}: {
  pageData?: ConsumerCoursePageFieldsFragment;
  size?: 'small' | 'large';
  // WARNING: This will hide dynamic critical links/messages next to the enroll button (like finaid link).
  // Only add this prop if the button is being used as the non-primary CTA (like in page nav).
  onlyShowButton?: boolean;
}) => {
  if (!pageData) {
    return null;
  }

  const courseData = getFormattedCourseDataFromConsumerCoursePageFieldsFragment(pageData);

  return (
    <ConsumerEnrollButtonNotConfigurable
      s12nId={pageData.activeSpecialization ? pageData.activeSpecialization.id : pageData.primarySpecialization?.id}
      partnerIds={pageData?.partners?.map(({ id }) => id)}
      courseCount={
        pageData.activeSpecialization
          ? pageData.activeSpecialization.courseCount
          : pageData.primarySpecialization?.courseCount
      }
      onStickyHeader={size === 'small'}
      onlyShowButton={onlyShowButton}
      isSpecialization={false}
      name={pageData.name}
      slug={pageData.slug}
      courseId={pageData.id}
      course={courseData}
    />
  );
};

export default ConsumerCourseEnrollButtonNotConfigurable;
